<template>
  <div class="new-invoice pb-9">
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <div class="pa-6 d-flex flex-column">
          <div class="mb-6">
            <v-btn
              elevation="3"
              height="45"
              color="grey darken-1"
              class="me-3"
              outlined
              small
              style="border-radius: 6px !important; font-size: 17px !important"
              >N</v-btn
            >
            <b>افزودن مشتری</b>
          </div>
          <div>
            <v-btn
              elevation="3"
              height="45"
              color="grey darken-1"
              class="me-3"
              outlined
              small
              style="border-radius: 6px !important; font-size: 17px !important"
              >L</v-btn
            >
            <b>افزودن کالا به فاکتور</b>
          </div>
        </div>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <i
      hidden
      class="ms-3 fa fa-question-circle text-dark"
      v-shortkey.once="['l']"
      @shortkey="
        titleFilter = '';
        productsDialog = true;
      "
    ></i>
    <v-btn
      color="primary"
      style="float: right"
      @click="openAddCustomer()"
      v-shortkey.once="['n']"
      @shortkey="openAddCustomer()"
      hidden
    >
      ثبت مشتری جدید +
    </v-btn>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2 ps-2">{{ title }} جدید</h4>
      </div>

      <hr class="mt-5" />
      <div v-if="isLoading" class="text-center">
        <cube></cube>
        <span style="font-size: 16px">در حال بارگذاری ...</span>
      </div>
      <div v-else>
        <h4 class="c-purple mt-12">ثبت {{ title }} جدید</h4>
        <div class="d-flex flex-sm-row flex-column mt-5 ps-0 flex-wrap">
          <div class="custom-input d-flex flex-row ps-3 pe-3">
            <v-text-field
              outlined
              dense
              hide-details
              type="number"
              dir="ltr"
              label="شماره همراه مشتری"
              @keyup.enter="customerMobile ? searchCustomer() : ''"
              v-model="customerMobile"
            >
              <template v-slot:append>
                <span @click="searchCustomer()">
                  <v-icon>mdi-magnify</v-icon></span
                >
              </template>
            </v-text-field>

            <v-btn
              @click="searchCustomer()"
              class="blue-mainBtn ms-2"
              height="42"
              :disabled="!customerMobile"
            >
              جستجو
            </v-btn>
          </div>
          <div>
            <div class="custom-input ms-3">
              <v-autocomplete
                attach
                clearable
                :menu-props="{ bottom: true, offsetY: true }"
                @change="getBalance(newInvoice.shopCustomerId)"
                auto-select-first
                no-data-text="نتیجه‌ای یافت نشد!"
                v-model="newInvoice.shopCustomerId"
                :items="customers"
                item-text="name"
                item-value="id"
                class="mb-3 mt-sm-0 mt-2 me-sm-0 me-4 shop-select"
                label="نام مشتری"
                :loading="gettingCustomers"
                :disabled="gettingCustomers"
                dense
                outlined
              >
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  <!--<img
                  v-if="data.item.royaltyTier"
                  :src="computedIcon(data.item)"
                  style="height: 26px; width: 26px"
                  class="me-1"
                />-->
                  {{ data.item.name }}
                </template>
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  <!--<img
                  v-if="data.item.royaltyTier"
                  :src="computedIcon(data.item)"
                  style="height: 26px; width: 26px"
                  class="me-1"
                />-->
                  {{ data.item.name }}
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>
        <div
          v-if="gettingBalance"
          class="pa-5 d-flex justify-center align-center"
        >
          <v-progress-circular
            indeterminate
            color="purple"
          ></v-progress-circular>
        </div>
        <div
          v-if="newInvoice.shopCustomerId && !gettingBalance"
          class="customer-info grey--text text--darken-2 mt-6 mb-3"
        >
          <v-row>
            <v-col>
              <b class="me-1">مانده حساب:</b>
              <span v-if="newInvoice.customerBalance" class="ms-2">{{
                newInvoice.customerBalance
              }}</span>
            </v-col>
            <v-col>
              <b class="me-1">مبلغ کل پرداختی‌های پیشین:</b>
              {{ Number(allShopIncomeBalance).toLocaleString() }} ریال
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col>
            <b class="me-1">نوع اعتبار:</b> {{ royaltyCreditType }}
          </v-col> -->
            <!-- <v-col>
            <b class="me-1">میزان اعتبار باقی مانده:</b>
            {{ Number(royaltyCreditAmount).toLocaleString() }} ریال
          </v-col> -->
          </v-row>
        </div>
        <hr />
        <v-row>
          <v-col>
            <v-btn
              @click="
                titleFilter = '';
                productsDialog = true;
                currentPage = 1;
              "
              height="50"
              class="purple-borderedBtn w-100"
              ><v-icon class="me-2">$Box</v-icon> افزودن کالا با قیمت پیش‌ فرض
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              @click="
                titleFilter = '';
                productsIntendedDialog = true;
                currentPage2 = 1;
              "
              height="50"
              class="purple-borderedBtn w-100"
              ><v-icon class="me-2">$Box</v-icon> افزودن کالا با قیمت دلخواه
            </v-btn>
          </v-col>
        </v-row>
        <span v-show="false">{{ reactivity }}</span>
        <div class="custom-table dashed mt-8 pb-2">
          <b-table
            responsive
            show-empty
            :items="selectedProducts"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="هنوز کالایی به فاکتور اضافه نشده است"
            striped
            thead-class="headClass"
            tbody-class="bodyClass"
            :current-page="productCurrentPage"
            :per-page="productPerPage"
          >
            <template v-slot:empty>
              <div
                style="text-align: center; vertical-align: middle"
                class="mt-2"
              >
                <v-icon class="red--text text--lightem-1 me-2"
                  >mdi-alert-circle-outline</v-icon
                >
                <span class="red--text font-weight-bold text--lightem-1"
                  >هنوز کالایی به فاکتور اضافه نشده است</span
                >
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + productPerPage * (productCurrentPage - 1) }}
              </div>
            </template>
            <template v-slot:head(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(name)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  min-width: 300px;
                "
              >
                <span v-if="isPriceChanged(data)" class="me-1">*</span>
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(amount)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="d-flex flex-row justify-space-around align-center"
              >
                <span v-show="false">{{ reactivity }}</span>

                <div class="d-flex">
                  <div
                    class="count-btn ms-1"
                    @click="addItem(data.item, 1, data.index, 'direct')"
                    dir="ltr"
                  >
                    <span>+</span>
                  </div>
                </div>
                <v-text-field
                  class="countField ms-2 me-2"
                  outlined
                  dense
                  v-model="data.value"
                  hide-details
                  type="number"
                  @change="changeCount(data.item, data.value)"
                ></v-text-field>
                <div class="d-flex">
                  <div
                    class="count-btn"
                    @click="reduceItem(data.item, data.index, 1)"
                    dir="ltr"
                  >
                    <span>-</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-slot:cell(totalPrice)="data">
              <div style="text-align: center; vertical-align: middle">
                <span v-show="false">{{ reactivity }}</span>
                {{
                  (Number(data.item.amount) * data.item.price).toLocaleString()
                }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="text-align: center; vertical-align: middle"
                class="pt-0"
              >
                <span
                  class="pointer"
                  @click="
                    openDeleteModal(
                      data.index + productPerPage * (productCurrentPage - 1),
                      data.item
                    )
                  "
                >
                  <v-icon>$Delete</v-icon></span
                >
              </div>
            </template>
          </b-table>

          <div v-if="selectedProducts.length">
            <v-row class="mt-6">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box-new">
                    <v-select
                      class="shop-select"
                      attach
                      :menu-props="{ bottom: true, offsetY: true }"
                      outlined
                      dense
                      v-model="productPerPage"
                      :items="perPageOptions"
                      @change="productCurrentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="productCurrentPage"
                    :length="
                      Math.ceil(selectedProducts.length / productPerPage)
                    "
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
            <hr class="my-8" />
            <v-row class="custom-input">
              <v-col md="6" cols="12">
                <span id="invoiceDate">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-edit"
                    v-model="newInvoice.date"
                    label="تاریخ"
                    :editable="true"
                    class="mt-2"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="newInvoice.date"
                  element="invoiceDate"
                  color="#9c7fb7"
              /></v-col>
              <v-col md="6" cols="12">
                <span id="invoiceTime">
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    append-icon="mdi-calendar-edit"
                    v-model="newInvoice.time"
                    label="ساعت"
                    :editable="true"
                    class="mt-2"
                  >
                  </v-text-field>
                </span>

                <date-picker
                  v-model="newInvoice.time"
                  element="invoiceTime"
                  color="#9c7fb7"
                  type="time"
              /></v-col>
            </v-row>
            <v-row>
              <v-col lg="6" md="12" cols="12">
                <!-- <div class="mb-7" v-if="Number(royaltyCreditAmount) > 0">
                <span
                  @click="
                    newInvoice.useCredit = !newInvoice.useCredit;
                    newInvoice.discount = 0;
                  "
                  class="pointer"
                >
                  <v-icon v-if="newInvoice.useCredit"> $Purplechecked </v-icon>
                  <v-icon v-else> $PurpleUnchecked </v-icon>
                  <span
                    class="ms-3"
                    :class="
                      !newInvoice.useCredit
                        ? 'grey--text text--darken-2'
                        : 'c-purple font-weight-bold'
                    "
                    >استفاده از مبلغ اعتبار</span
                  >
                </span>
              </div> -->
                <div class="custom-input mb-7">
                  <!--<v-row class="mt-0">
                  <v-col cols="6">
                    <v-checkbox
                      v-if="false"
                      v-model="useRoyaltyCredit"
                      label="استفاده از اعتبار"
                      class="mt-0 royaltyCredit"
                    ></v-checkbox>
                  </v-col>
                </v-row>-->
                  <v-text-field
                    label="تخفیف (درصد)"
                    :disabled="disableDiscount()"
                    v-model="newInvoice.discountPercentage"
                    hide-details
                    type="number"
                    outlined
                    dense
                    min="0"
                    max="100"
                    oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; this.value = Math.abs(this.value)"
                    class="w-100"
                  ></v-text-field>
                </div>
                <div class="custom-input mb-7">
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    type="number"
                    min="0"
                    max="100"
                    oninput="if(Number(this.value) > Number(this.max)) this.value = this.max; this.value = Math.abs(this.value)"
                    label="مالیات (درصد)"
                    class="w-100"
                    v-model="newInvoice.vat"
                  ></v-text-field>
                </div>
                <div class="custom-input mb-1" v-if="invoiceType == 'proforma'">
                  <span id="expirationDate">
                    <v-text-field
                      outlined
                      dense
                      type="text"
                      append-icon="mdi-calendar-edit"
                      v-model="newInvoice.expirationDate"
                      label="تاریخ انقضا"
                      :editable="true"
                      class="date-input"
                    >
                    </v-text-field>
                  </span>

                  <date-picker
                    v-model="newInvoice.expirationDate"
                    element="expirationDate"
                    color="#9c7fb7"
                  />
                </div>
                <div class="custom-input mb-1" v-else>
                  <v-select
                    class="shop-select"
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                    dense
                    outlined
                    hide-details
                    label="نوع پرداخت"
                    :items="sellingTypes"
                    v-model="newInvoice.sellingType"
                    @change="reactivity = !reactivity"
                  >
                    <template v-slot:append>
                      <v-icon>$ArrowDown</v-icon>
                    </template>
                  </v-select>
                </div>
              </v-col>
              <v-col lg="6" md="12" cols="12">
                <div class="custom-input mt-0">
                  <v-textarea
                    rows="7"
                    no-resize
                    dense
                    outlined
                    hide-details
                    label="توضیحات"
                    v-model="newInvoice.income.description"
                  >
                  </v-textarea>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="custom-input mt-0">
                  <v-text-field
                    no-resize
                    dense
                    outlined
                    hide-details
                    label="متن زیر فاکتور"
                    v-model="newInvoice.subInvoiceLine"
                  >
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
            <div
              v-if="
                newInvoice.sellingType == 'definite' && invoiceType == 'invoice'
              "
            >
              <div class="custom-input mt-6">
                <v-select
                  class="shop-select"
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                  dense
                  outlined
                  hide-details
                  label="نحوه پرداخت"
                  :items="paymentTypes"
                  v-model="newInvoice.income.paymentType"
                >
                  <template v-slot:append>
                    <v-icon>$ArrowDown</v-icon>
                  </template>
                </v-select>
              </div>
              <div
                v-if="newInvoice.income.paymentType == 'cheque'"
                class="pa-5 pt-10 mb-2 mt-8"
                style="
                  border: 1px solid #ccc;
                  border-radius: 12px;
                  position: relative;
                "
              >
                <p
                  class="ps-4 pe-4 c-grey"
                  style="position: absolute; top: -9px; background-color: #fff"
                >
                  اطلاعات چک را وارد کنید:
                </p>
                <v-row class="custom-input">
                  <v-col class="py-0" sm="6" cols="12">
                    <v-text-field
                      type="number"
                      label="شماره چک"
                      v-model="newInvoice.income.chequeNo"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col class="py-0" sm="6" cols="12">
                    <v-text-field
                      label="نام بانک"
                      v-model="newInvoice.income.chequeBank"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="custom-input">
                  <v-col class="py-0" sm="6" cols="12">
                    <v-text-field
                      type="number"
                      label="شماره صیاد"
                      v-model="newInvoice.income.chequeSayyad"
                      outlined
                      dense
                      class="my-2"
                    ></v-text-field>
                    <v-select
                      class="shop-select mb-1"
                      attach
                      :menu-props="{ bottom: true, offsetY: true }"
                      v-model="newInvoice.income.chequeStatus"
                      dense
                      outlined
                      hide-details
                      label="وضعیت چک"
                      :items="chequeStatuses"
                    >
                      <template v-slot:append>
                        <v-icon>$ArrowDown</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col class="pt-0" sm="6" cols="12">
                    <span id="chequeDate">
                      <v-text-field
                        outlined
                        dense
                        type="text"
                        append-icon="mdi-calendar-edit"
                        v-model="newInvoice.income.chequeDate"
                        label="تاریخ چک"
                        :editable="true"
                        class="mt-2"
                      >
                      </v-text-field>
                    </span>

                    <date-picker
                      v-model="newInvoice.income.chequeDate"
                      element="chequeDate"
                      color="#9c7fb7"
                    />
                  </v-col>
                </v-row>
                <div v-if="computedchequeInfo" class="d-flex flex-row mt-2">
                  <v-icon class="red--text me-1"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <span class="red--text"
                    >وارد کردن شماره چک، نام بانک و تاریخ چک الزامی است.</span
                  >
                </div>
              </div>
              <div
                v-if="newInvoice.income.paymentType == 'cardTransfer'"
                class="pa-5 pt-10 mb-2 mt-8"
                style="
                  border: 1px solid #ccc;
                  border-radius: 12px;
                  position: relative;
                "
              >
                <p
                  class="ps-4 pe-4 c-grey"
                  style="position: absolute; top: -9px; background-color: #fff"
                >
                  اطلاعات کارت‌‌ها:
                </p>
                <v-row class="custom-input">
                  <v-col class="py-0" sm="6" cols="12">
                    <v-text-field
                      label="شماره کارت فرستنده"
                      v-model="newInvoice.income.buyerCardNumber"
                      outlined
                      dense
                      class="mb-1"
                      type="number"
                      data-maxlength="16"
                      oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                    ></v-text-field>
                    <getBankNameFromCardNumber
                      v-if="newInvoice.income.buyerCardNumber"
                      :digits="newInvoice.income.buyerCardNumber"
                      v-slot="{ bankName }"
                    >
                      <h6 v-if="bankName" class="me-3 mt-3">
                        نام بانک: {{ bankName }}
                      </h6></getBankNameFromCardNumber
                    >
                  </v-col>

                  <v-col class="py-0" sm="6" cols="12">
                    <v-text-field
                      label="شماره کارت گیرنده"
                      v-model="newInvoice.income.recipientCardNumber"
                      outlined
                      dense
                      class="mb-1"
                      type="number"
                      data-maxlength="16"
                      oninput="this.value=this.value.slice(0,this.dataset.maxlength)"
                    ></v-text-field>
                    <getBankNameFromCardNumber
                      v-if="newInvoice.income.recipientCardNumber"
                      :digits="newInvoice.income.recipientCardNumber"
                      v-slot="{ bankName }"
                    >
                      <h6 v-if="bankName" class="me-3 mt-3">
                        نام بانک: {{ bankName }}
                      </h6></getBankNameFromCardNumber
                    >
                  </v-col>
                </v-row>
                <div v-if="computedCardInfo" class="d-flex flex-row mt-5">
                  <v-icon class="red--text me-1"
                    >mdi-alert-circle-outline</v-icon
                  >
                  <span class="red--text"
                    >وارد کردن شماره کارت فرستنده و گیرنده الزامی است.</span
                  >
                </div>
              </div>
              <v-row class="mt-3">
                <v-col cols="6">
                  <v-checkbox
                    v-model="newInvoice.income.isPartial"
                    label="به‌ عنوان پرداخت جزیی ثبت شود"
                    class="mt-0 checkboxPartial"
                    @change="partialAmount()"
                  ></v-checkbox>
                </v-col>
                <v-col
                  cols="6"
                  v-if="newInvoice.income.isPartial"
                  class="custom-input mt-0"
                >
                  <vuetify-money
                    label="مبلغ"
                    v-model="newInvoice.income.partialAmount"
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    hide-details
                    type="number"
                    outlined
                    dense
                    class="w-100 mt-0"
                  />
                </v-col>
              </v-row>
            </div>

            <hr class="my-8" />
            <v-row class="c-grey" style="font-size: 17px">
              <v-col lg="6" md="12" cols="12">
                <v-row>
                  <v-col>
                    <span> قیمت کل </span>
                  </v-col>
                  <v-col>
                    {{ Number(computedTotalPrice).toLocaleString() + " ریال " }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> تخفیف </span>
                  </v-col>
                  <v-col>
                    {{ computedTotalDiscount }}
                  </v-col>
                </v-row>
                <!--<v-row v-if="newInvoice.useCredit">
                <v-col>
                  <span> مبلغ اعتبار </span>
                </v-col>
                <v-col>
                  {{ Number(royaltyCreditAmount).toLocaleString() + ' ریال ' }}
                </v-col>
              </v-row>-->
                <v-row>
                  <v-col>
                    <span> مالیات (ریال) </span>
                  </v-col>
                  <v-col>
                    {{
                      parseInt(
                        ((selectedProducts
                          .map((x) => Number(x.price) * Number(x.amount))
                          .reduce((a, b) => a + b, 0) -
                          (selectedProducts
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) *
                            newInvoice.discountPercentage) /
                            100) *
                          newInvoice.vat) /
                          100
                      ) > 0
                        ? parseInt(
                            ((selectedProducts
                              .map((x) => Number(x.price) * Number(x.amount))
                              .reduce((a, b) => a + b, 0) -
                              (selectedProducts
                                .map((x) => Number(x.price) * Number(x.amount))
                                .reduce((a, b) => a + b, 0) *
                                newInvoice.discountPercentage) /
                                100) *
                              newInvoice.vat) /
                              100
                          ).toLocaleString() + " ریال "
                        : 0
                    }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr class="mt-8 mb-4" />
            <v-row class="c-grey my-4" style="font-size: 19px">
              <v-col lg="6" md="12" cols="12" class="pb-0">
                <v-row>
                  <v-col>
                    <span> مبلغ قابل پرداخت</span>
                  </v-col>
                  <v-col>
                    <span v-show="false">{{ reactivity }}</span>
                    {{
                      !computedDiscount
                        ? "مبلغ کل فاکتور منفی شده است."
                        : computedDiscount
                    }}
                  </v-col>
                  <!--<v-col v-else-if="newInvoice.useCredit">
                  {{
                    royaltyCreditAmount >
                    selectedProducts
                      .map((x) => Number(x.price) * Number(x.amount))
                      .reduce((a, b) => a + b, 0) *
                      (1 + Number(this.newInvoice.vat) / 100)
                      ? 0
                      : parseInt(
                          selectedProducts
                            .map((x) => Number(x.price) * Number(x.amount))
                            .reduce((a, b) => a + b, 0) *
                            (1 + Number(this.newInvoice.vat) / 100) -
                            Number(royaltyCreditAmount)
                        ).toLocaleString() + " ریال "
                  }}
                  + ریال
                </v-col>-->
                </v-row>
                <v-row v-if="newInvoice.income.isPartial">
                  <v-col>
                    <span> مبلغ پرداخت جزئی</span>
                  </v-col>
                  <v-col>
                    {{
                      Number(newInvoice.income.partialAmount).toLocaleString() +
                      " ریال "
                    }}
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="text-left pb-0">
                <v-btn
                  @click="addInvoice()"
                  :disabled="
                    invoiceType == 'proforma'
                      ? disabledProforma
                      : disabledInvoice
                  "
                  class="purple-mainBtn"
                  width="90"
                >
                  <span class="white--text">
                    <v-icon small class="white--text me-1"
                      >mdi-check-outline</v-icon
                    >
                    ثبت
                  </span></v-btn
                >
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" timeout="2000" color="green" top>
      <div class="w-100 text-center">
        <v-icon class="white--text me-1">mdi-check-decagram</v-icon>
        {{ text }}
      </div>
    </v-snackbar>
    <v-snackbar v-model="errorSnackbar" timeout="2000" color="red" top>
      <div class="w-100 text-center">
        <v-icon class="white--text me-1">mdi-alert-circle-outline</v-icon>
        موجودی انبار کافی نیست!
      </div>
    </v-snackbar>
    <!-- products dialog -->
    <v-dialog v-model="productsDialog" width="800" persistent>
      <v-card class="dialog-card">
        <div>
          <div class="d-flex flex-row justify-space-between pa-3">
            <div class="d-flex flex-row">
              <h4 class="mb-0 pt-2">محصولات</h4>
              <v-divider class="me-10 ms-10" vertical></v-divider>
              <div class="custom-input2">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در محصولات..."
                  prepend-icon="$Search"
                  @input="
                    currentPage = 1;
                    reactivity = !reactivity;
                  "
                  v-model="titleFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="titleFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        titleFilter = '';
                        currentPage = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
              <v-divider class="me-10 ms-10" vertical></v-divider>
            </div>
            <span class="pointer" @click="productsDialog = false"
              ><v-icon class="close-icon me-5 mt-2">$Close</v-icon></span
            >
          </div>
          <hr />
          <div
            v-if="productsLoading"
            class="d-flex flex-column align-items-center mt-8 py-6"
          >
            <cube></cube>
            <span style="font-size: 16px">در حال بارگذاری ...</span>
          </div>
          <div v-else class="custom-table mt-5">
            <b-table
              responsive
              show-empty
              stacked="sm"
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedProducts"
              :fields="productsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(name)="data">
                <div style="text-align: right; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div
                  style="
                    text-align: right;
                    vertical-align: middle;
                    min-width: 200px;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ Number(data.value).toLocaleString() }}
                </div>
              </template>
              <template v-slot:cell(sum)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    margin-top: -4px;
                  "
                >
                  <div v-if="Number(data.value) == 0" class="red-badge mx-auto">
                    اتمام موجودی
                  </div>
                  <div v-else>{{ data.value }}</div>
                </div>
              </template>

              <template v-slot:cell(operation)="data">
                <span v-show="false">{{ reactivity }}</span>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="d-flex justify-space-between pt-0"
                >
                  <v-tooltip
                    top
                    v-if="
                      !products2[data.index + perPage * (currentPage - 1)]
                        .manualPrice
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn
                          @click="
                            addItem(
                              data.item,
                              1,
                              data.index + perPage * (currentPage - 1),
                              'indirect'
                            );
                            products[
                              data.index + perPage * (currentPage - 1)
                            ].currentPrice = true;
                            products[
                              data.index + perPage * (currentPage - 1)
                            ].manualPrice = false;
                            reactivity = !reactivity;
                          "
                          class="purple-mainBtn"
                          width="40"
                          ><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>افزودن یک قلم کالا</span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-on="on" v-bind="attrs">
                        <v-btn
                          disabled
                          @click="
                            addItem(
                              data.item,
                              1,
                              data.index + perPage * (currentPage - 1),
                              'indirect'
                            );
                            products[
                              data.index + perPage * (currentPage - 1)
                            ].currentPrice = true;
                            products[
                              data.index + perPage * (currentPage - 1)
                            ].manualPrice = false;
                            reactivity = !reactivity;
                          "
                          class="purple-mainBtn"
                          width="40"
                          ><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span
                      > کالا مورد نظر با قیمت دلخواه به فاکتور اضافه شده است.
                    </span>
                  </v-tooltip>

                  <v-tooltip
                    top
                    v-if="
                      !products2[data.index + perPage * (currentPage - 1)]
                        .manualPrice
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn
                          @click="openFieldModal(data.item)"
                          v-bind="attrs"
                          v-on="on"
                          class="green-mainBtn ms-1"
                          width="60"
                          ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>افزودن به مقدار دلخواه</span>
                  </v-tooltip>

                  <v-tooltip top v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn
                          disabled
                          class="green-mainBtn ms-1"
                          @click="openFieldModal(data.item)"
                          width="60"
                          ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span
                      > کالا مورد نظر با قیمت دلخواه به فاکتور اضافه شده است.
                    </span>
                  </v-tooltip>
                </div>
              </template>
            </b-table>
            <div class="blue-custom-pagination mt-6">
              <v-pagination
                v-model="currentPage"
                :length="Math.ceil(computedProducts.length / perPage)"
                :total-visible="5"
                prev-icon="$ArrowLeft"
                next-icon="$ArrowRight"
                class="float-end"
              ></v-pagination>
            </div>
          </div>
          <hr />
          <div class="py-1">
            <div v-if="!selectedProducts.length">
              <v-icon class="red--text text--lightem-1 me-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="red--text font-weight-bold text--lightem-1"
                >هنوز کالایی به فاکتور اضافه نشده است.</span
              >
            </div>
            <div v-else>
              <v-icon class="purple-icon c-purple me-3">$BoxChecked</v-icon>
              <span class="c-purple"
                >{{
                  selectedProducts
                    .map((x) => Number(x.amount))
                    .reduce((a, b) => a + b, 0)
                }}
                کالا به فاکتور اضافه شد.</span
              >
              <v-btn
                @click="productsDialog = false"
                class="purple-borderedBtn ms-10"
                >دیدن فاکتور</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- products intended dialog -->
    <v-dialog v-model="productsIntendedDialog" width="800" persistent>
      <v-card class="dialog-card">
        <div>
          <div class="d-flex flex-row justify-space-between pa-3">
            <div class="d-flex flex-row">
              <h4 class="mb-0 pt-2">محصولات</h4>
              <v-divider class="me-10 ms-10" vertical></v-divider>
              <div class="custom-input2">
                <v-text-field
                  hide-details
                  outlined
                  dense
                  label="جستجو در محصولات..."
                  prepend-icon="$Search"
                  @input="
                    currentPage2 = 1;
                    reactivity = !reactivity;
                  "
                  v-model="titleFilter"
                >
                  <template v-slot:append>
                    <v-icon
                      v-if="titleFilter.length"
                      class="red--text text--lighten-2"
                      @click="
                        titleFilter = '';
                        currentPage2 = 1;
                      "
                      >mdi-close-circle</v-icon
                    >
                  </template>
                </v-text-field>
              </div>
              <v-divider class="me-10 ms-10" vertical></v-divider>
            </div>
            <span class="pointer" @click="productsIntendedDialog = false"
              ><v-icon class="close-icon me-5 mt-2">$Close</v-icon></span
            >
          </div>
          <hr />
          <div
            v-if="productsLoading"
            class="d-flex flex-column align-items-center mt-8 py-6"
          >
            <cube></cube>
            <span style="font-size: 16px">در حال بارگذاری ...</span>
          </div>
          <div v-else class="custom-table custom-intended-table mt-5">
            <b-table
              responsive
              show-empty
              stacked="sm"
              :current-page="currentPage2"
              :per-page="perPage2"
              :items="computedProducts2"
              :fields="productsFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:head(name)="data">
                <div style="text-align: right; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage2 * (currentPage2 - 1) }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(name)="data">
                <div
                  style="
                    text-align: right;
                    vertical-align: middle;
                    min-width: 200px;
                  "
                > 
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <div>
                  <vuetify-money
                    :valueWhenIsEmpty="whenIsEmpty"
                    :options="vMoneyOptions"
                    class="countField ms-2 me-2"
                    outlined
                    dense
                    v-model="data.value"
                    hide-details
                    type="number"
                    @input="
                      changePrice(
                        data.index + perPage2 * (currentPage2 - 1),
                        data.item,
                        data.value
                      )
                    "
                  />
                </div>
              </template>
              <template v-slot:cell(sum)="data">
                <span v-show="false">{{ reactivity }}</span>
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    margin-top: -4px;
                  "
                >
                  <div v-if="Number(data.value) == 0" class="red-badge mx-auto">
                    اتمام موجودی
                  </div>
                  <div v-else>{{ data.value }}</div>
                </div>
              </template>

              <template v-slot:cell(operation)="data">
                <span v-show="false">{{ reactivity }}</span>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="d-flex justify-space-between pt-0"
                >
                  <v-tooltip
                    v-if="
                      !products[data.index + perPage2 * (currentPage2 - 1)]
                        .currentPrice
                    "
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn
                          @click="
                            reactivity = !reactivity;
                            data.item.manualPrice = true;
                            data.item.currentPrice = false;
                            addItemProduct2(
                              data.item,
                              1,
                              data.index + perPage2 * (currentPage2 - 1),
                              'indirect'
                            );
                          "
                          class="purple-mainBtn"
                          width="40"
                          ><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span>افزودن یک قلم کالا</span>
                  </v-tooltip>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn
                          disabled
                          @click="
                            reactivity = !reactivity;
                            data.item.manualPrice = true;
                            data.item.currentPrice = false;
                            addItemProduct2(
                              data.item,
                              1,
                              data.index + perPage2 * (currentPage2 - 1),
                              'indirect'
                            );
                          "
                          class="purple-mainBtn"
                          width="40"
                          ><v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </span>
                    </template>
                    <span
                      > کالا مورد نظر با قیمت پیش فرض به فاکتور اضافه شده است.</span
                    >
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      !products[data.index + perPage2 * (currentPage2 - 1)]
                        .currentPrice
                    "
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                      v-bind="attrs"
                      v-on="on"
                      >
                      <v-btn
                        @click="openFieldModal2(data.item)"
                        class="green-mainBtn ms-1"
                        width="60"
                        ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                      </v-btn>
                      </span>
                    </template>
                    <span>افزودن به مقدار دلخواه</span>
                  </v-tooltip>
                  <v-tooltip
                    v-else
                    top
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span
                      v-bind="attrs"
                      v-on="on"
                      >
                      <v-btn
                        disabled
                        @click="openFieldModal2(data.item)"
                        class="green-mainBtn ms-1"
                        width="60"
                        ><v-icon>mdi-plus</v-icon><v-icon>mdi-plus</v-icon>
                      </v-btn>
                      </span>
                    </template>
                    <span> کالا مورد نظر با قیمت پیش فرض به فاکتور اضافه شده است.</span>
                  </v-tooltip>
                </div>
              </template>
            </b-table>
            <div class="blue-custom-pagination mt-6">
              <v-pagination
                v-model="currentPage2"
                :length="Math.ceil(computedProducts2.length / perPage2)"
                :total-visible="5"
                prev-icon="$ArrowLeft"
                next-icon="$ArrowRight"
                class="float-end"
              ></v-pagination>
            </div>
          </div>
          <hr />
          <div class="py-1">
            <div v-if="!selectedProducts.length">
              <v-icon class="red--text text--lightem-1 me-2"
                >mdi-alert-circle-outline</v-icon
              >
              <span class="red--text font-weight-bold text--lightem-1"
                >هنوز کالایی به فاکتور اضافه نشده است.</span
              >
            </div>
            <div v-else>
              <v-icon class="purple-icon c-purple me-3">$BoxChecked</v-icon>
              <span class="c-purple"
                >{{
                  selectedProducts
                    .map((x) => Number(x.amount))
                    .reduce((a, b) => a + b, 0)
                }}
                کالا به فاکتور اضافه شد.</span
              >
              <v-btn
                @click="productsIntendedDialog = false"
                class="purple-borderedBtn ms-10"
                >دیدن فاکتور</v-btn
              >
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!-- delete product dialog -->
    <v-dialog v-model="deleteModal" width="600">
      <v-card class="modal-card">
        <h5 class="dark-grey-color py-5">
          <v-icon color="error">$Alert</v-icon>
          <span class="ps-2 pe-2 pt-1"
            >آیا از حدف محصول {{ selectedItem.name }} اطمینان دارید؟</span
          >
        </h5>
        <div class="text-left mt-9">
          <v-btn
            class="purple-mainBtn"
            width="90"
            @click="removeItem(selectedIndex, selectedItem)"
            >بله</v-btn
          >
          <v-btn
            class="red-borderedBtn ms-2"
            width="90"
            @click="deleteModal = false"
            >بازگشت</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- choose amount for product dialog -->
    <v-dialog v-model="fieldModal" width="400">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">تعداد محصول</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="fieldModal = false">
                <v-icon class="close-icon">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <h6 class="mb-5">مقدار محصول مورد نظر خود را وارد نمایید:</h6>
              <div class="custom-input">
                <v-text-field
                  outlined
                  dense
                  label="تعداد"
                  v-model="productsAmount"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="text-left ps-4 pe-5 pb-4">
          <v-btn
            @click="addProductItem(selectedRow, productsAmount)"
            :disabled="!productsAmount"
            class="purple-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- choose amount for product dialog -->
    <v-dialog v-model="fieldModal2" width="400">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">تعداد محصول</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="fieldModal2 = false">
                <v-icon class="close-icon">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <h6 class="mb-5">مقدار محصول مورد نظر خود را وارد نمایید:</h6>
              <div class="custom-input">
                <v-text-field
                  outlined
                  dense
                  label="تعداد"
                  v-model="productsAmount"
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="text-left ps-4 pe-5 pb-4">
          <v-btn
            @click="addProductItem2(selectedRow, productsAmount)"
            :disabled="!productsAmount"
            class="purple-mainBtn white--text"
            width="90"
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!-- add customer dialog -->
    <v-dialog v-model="newCustomerDialog" width="700">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت مشتری جدید</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newCustomerDialog = false">
                <v-icon class="close-icon">$Close</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <div class="custom-input">
                <v-text-field
                  outlined
                  dense
                  label="نام مشتری"
                  v-model="newCustomer.name"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="custom-input">
                <v-text-field
                  outlined
                  dense
                  label="شماره موبایل"
                  :loading="busy"
                  v-model="newCustomer.mobile"
                ></v-text-field>
                <div v-if="newCustomer.mobile">
                  <phoneNumber
                    :number="newCustomer.mobile"
                    v-slot="{ isValid }"
                  >
                    <div v-if="!isValid" style="vertical-align: middle">
                      <v-icon class="red--text me-1"
                        >mdi-alert-circle-outline</v-icon
                      >
                      <span class="red--text">شماره موبایل معتبر نیست</span>
                    </div>
                  </phoneNumber>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="custom-input">
                <v-select
                  class="shop-select"
                  attach
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="نوع مشتری"
                  :items="customerTypes"
                  v-model="newCustomer.type"
                  :loading="busy"
                  outlined
                  dense
                />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <div class="text-left py-5 ps-4 pe-4">
          <v-btn
            @click="newCustomerDialog = false"
            class="red-borderedBtn ms-2 me-2"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="addCustomer()"
            class="purple-mainBtn white--text"
            width="90"
            :disabled="
              !(newCustomer.name && newCustomer.mobile && newCustomer.type)
            "
          >
            ثبت
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import { getBankNameFromCardNumber } from "@persian-tools/vue-persian-tools/dist/modules";
import moment from "moment-jalaali";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import prices from "../../mixins/prices";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    getBankNameFromCardNumber,
  },
  mixins: [prices],
  data() {
    return {
      selectedIndex: "",
      selectedItem: {},
      deleteModal: false,
      type: "newinvoice",
      useRoyaltyCredit: false,
      chequeStatuses: [
        { value: "passed", text: "پاس شده" },
        { value: "returned", text: "برگشت خورده" },
        { value: "submitted", text: "ثبت شده" },
      ],
      moment: moment,
      getReceiptDialog: false,
      guide: false,
      reactivity: false,
      snackbar: false,
      errorSnackbar: false,
      busy: false,
      text: "",
      customers: [],
      products: [],
      products2: [],
      productsAmount: null,
      selectedProducts: [],
      newCustomer: {},
      cheque: {},
      titleFilter: "",
      //   barcodeFilter: "",
      perPage: 5,
      currentPage: 1,
      perPage2: 5,
      currentPage2: 1,
      productsDialog: false,
      productsIntendedDialog: false,
      productsLoading: false,
      gettingCustomers: true,
      newCustomerDialog: false,
      customerMobile: null,
      receiptNumber: "",
      royaltyCreditAmount: null,
      allShopIncomeBalance: null,
      royaltyCreditType: "none",
      newInvoice: {
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,

        vat: 0,
        discount: 0,
        discountPercentage: 0,
        useCredit: false,
        shopInvoiceId: "",
        sellingType: "respite",
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
        expirationDate: moment(new Date())
          .add(7, "days")
          .format("jYYYY/jMM/jDD"),
        income: {
          paymentType: "cash",
          isPartial: false,
          partialAmount: 0,
        },
      },
      gettingBalance: false,
      paymentTypes: [
        { value: "cash", text: "نقدی" },
        { value: "card", text: "کارتخوان" },
        { value: "cheque", text: "چک" },
        { value: "cardTransfer", text: "کارت به کارت" },
      ],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "code", label: "کد محصول" },
        { key: "price", label: "قیمت واحد (ریال)" },
        { key: "amount", label: "تعداد" },
        { key: "totalPrice", label: "قیمت کل (ریال)" },
        { key: "operation", label: "عملیات" },
      ],
      productsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام محصول" },
        { key: "code", label: "کد محصول" },
        { key: "price", label: "قیمت (ریال)" },
        { key: "sum", label: "موجودی انبار" },
        { key: "operation", label: "عملیات" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      sellingTypes: [
        { value: "definite", text: "قطعی - پرداخت در لحظه" },
        { value: "respite", text: "امانی - پرداخت اعتباری" },
      ],
      addBusy: false,
      productPerPage: 10,
      productCurrentPage: 1,
      perPageOptions: [4, 10, 20],
      invoiceType: null,
      fieldModal: false,
      fieldModal2: false,
      selectedRow: {},
      routeUpdated: false,
      hasData: false,
      expireDuration: "",
      oldBalance: "",
      isLoading: false,
    };
  },
  methods: {
    isPriceChanged(data) {
      if (data.item.manualPrice) {
        return true;
      } else {
        return false;
      }
    },
    addProductItem(item, amount) {
      if (item.sum > 0 && item.sum >= amount) {
        let myIndex = this.products.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (myIndex > -1) {
          this.snackbar = true;
          this.products[myIndex].sum =
            Number(this.products[myIndex].sum) - Number(amount);
        }

        let selecttedIndex = this.selectedProducts.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (selecttedIndex == -1) {
          this.snackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.selectedProducts.push(thisItem);
        } else {
          this.snackbar = false;
          this.selectedProducts[selecttedIndex].amount =
            Number(this.selectedProducts[selecttedIndex].amount) +
            Number(amount);
          this.reactivity = !this.reactivity;
        }
        this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
        setTimeout(() => {
          this.snackbar = true;
        }, 100);
        this.products2[myIndex].sum = item.sum;
        this.products[myIndex].currentPrice = true;
        this.products[myIndex].manualPrice = false;
        this.reactivity = !this.reactivity;
        this.fieldModal = false;
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    addProductItem2(item, amount) {
      if (item.sum > 0 && item.sum >= amount) {
        let myIndex = this.products2.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (myIndex > -1) {
          this.snackbar = true;
          this.products2[myIndex].sum =
            Number(this.products2[myIndex].sum) - Number(amount);
        }

        let selecttedIndex = this.selectedProducts.findIndex(
          (product) => product.id == this.selectedRow.id
        );
        if (selecttedIndex == -1) {
          this.snackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.selectedProducts.push(thisItem);
        } else {
          this.snackbar = false;
          this.selectedProducts[selecttedIndex].amount =
            Number(this.selectedProducts[selecttedIndex].amount) +
            Number(amount);
          this.reactivity = !this.reactivity;
        }
        this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
        setTimeout(() => {
          this.snackbar = true;
        }, 100);
        this.products[myIndex].sum = item.sum;
        this.products2[myIndex].currentPrice = false;
        this.products2[myIndex].manualPrice = true;
        this.fieldModal2 = false;
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    openFieldModal(item) {
      this.selectedRow = item;
      this.productsAmount = 0;
      this.fieldModal = true;
      this.reactivity = !this.reactivity;
    },
    openFieldModal2(item) {
      this.selectedRow = item;
      this.productsAmount = 0;
      this.fieldModal2 = true;
      this.reactivity = !this.reactivity;
    },
    partialAmount() {
      if (this.newInvoice.income.isPartial) {
        if (this.computedTotalCost > 0)
          this.newInvoice.income.partialAmount = this.computedTotalCost;
      }
    },
    openDeleteModal(index, item) {
      this.selectedIndex = index;
      this.selectedItem = item;
      this.deleteModal = true;
    },
    disableDiscount() {
      if (this.useRoyaltyCredit) {
        this.newInvoice.discount = 0;
        return true;
      }
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    openAddCustomer() {
      this.newCustomer = {};
      this.guide = false;
      this.newCustomerDialog = true;
    },
    changeCount(item, amount) {
      item.amount = amount;
      this.reactivity = !this.reactivity;
    },
    changePrice(index, item, amount) {
      item.price = amount;
      this.reactivity = !this.reactivity;
    },
    addItem(item, amount, index, type) {
      if (item.sum > 0) {
        let myIndex = this.selectedProducts.findIndex(
          (product) => product.id == item.id
        );
        if (myIndex == -1) {
          this.snackbar = false;
          this.errorSnackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.selectedProducts.push(thisItem);
        } else {
          this.snackbar = false;
          this.errorSnackbar = false;
          this.selectedProducts[myIndex].amount =
            Number(this.selectedProducts[myIndex].amount) + Number(amount);
          this.reactivity = !this.reactivity;
        }
        item.sum--;
        this.products2[index].sum = item.sum;
        if (type == "indirect") {
          this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
          setTimeout(() => {
            this.snackbar = true;
          }, 100);
        }
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    addItemProduct2(item, amount, index, type) {
      if (item.sum > 0) {
        let myIndex = this.selectedProducts.findIndex(
          (product) => product.id == item.id
        );
        if (myIndex == -1) {
          this.snackbar = false;
          this.errorSnackbar = false;
          let thisItem = item;
          thisItem.amount = Number(amount);
          this.selectedProducts.push(thisItem);
        } else {
          this.snackbar = false;
          this.errorSnackbar = false;
          this.selectedProducts[myIndex].amount =
            Number(this.selectedProducts[myIndex].amount) + Number(amount);
          this.reactivity = !this.reactivity;
        }
        item.sum--;
        this.products[index].sum = item.sum;
        if (type == "indirect") {
          this.text = amount + " عدد " + item.name + " به فاکتور افزوده شد";
          setTimeout(() => {
            this.snackbar = true;
          }, 100);
        }
      } else {
        this.snackbar = false;
        this.errorSnackbar = true;
      }
    },
    removeItem(index, item) {
      this.selectedProducts.splice(index, 1);
      this.products.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
          x.manualPrice = false;
          x.currentPrice = false;
        }
      });
      this.products2.forEach((x) => {
        if (x.id == item.id) {
          x.sum = x.sum + item.amount;
          x.manualPrice = false;
          x.currentPrice = false;
        }
      });
      this.productCurrentPage = 1;

      this.deleteModal = false;
    },
    reduceItem(item, index, amount) {
      let myamount = item.amount;
      if (myamount <= amount) {
        this.selectedProducts.splice(index, 1);
      } else {
        this.selectedProducts[index].amount =
          Number(this.selectedProducts[index].amount) - Number(amount);
        this.reactivity = !this.reactivity;
      }
      item.sum = item.sum + amount;
    },
    getCustomers() {
      this.gettingCustomers = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingCustomers = false;
          if (res.status == 200) {
            this.customers = res.data;
            if (this.tempCustomer) {
              this.newInvoice.shopCustomerId = this.tempCustomer;
              this.getBalance(this.tempCustomer);
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.gettingCustomers = false;
          this.toast(err.response.data, "error");
        });
    },
    getBalance(customerId) {
      this.gettingBalance = true;
      this.newInvoice.customerBalance = "";
      if(customerId) {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/payments/customerBalance",
        {
          shopCustomerId: customerId,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            // this.royaltyCreditAmount = res.data.royaltyCreditAmount;
            this.allShopIncomeBalance = res.data.allShopIncomeBalance;
            // let royaltyCreditType = res.data.royaltyCreditType;
            // this.royaltyCreditType =
            //   royaltyCreditType == "normal"
            //     ? "معمولی"
            //     : royaltyCreditType == "vip"
            //     ? "ویژه"
            //     : "فاقد اعتبار";
            this.oldBalance = res.data.balanceData;
            this.newInvoice.customerBalance = res.data.balanceData;
            if (this.newInvoice.customerBalance > 0) {
              this.newInvoice.customerBalance =
                this.newInvoice.customerBalance.toLocaleString() +
                " ریال بدهکار";
            } else if (this.newInvoice.customerBalance < 0) {
              this.newInvoice.customerBalance =
                Math.abs(this.newInvoice.customerBalance).toLocaleString() +
                " ریال بستانکار";
            } else {
              this.newInvoice.customerBalance = "تسویه";
            }
            setTimeout(() => {
              this.gettingBalance = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.gettingBalance = false;
          }
        })
        .catch((err) => {
          this.gettingBalance = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
      } else {
        this.gettingBalance = false;
      }
    },
    searchCustomer() {
      this.busy = true;
      let myCustomer = {};
      myCustomer = this.customers.filter(
        (x) => x.mobile == this.customerMobile
      );
      if (myCustomer.length == 0) {
        this.newCustomer = {
          mobile: this.customerMobile,
          type: "naturalPerson",
        };
        this.newCustomerDialog = true;
      } else {
        this.newInvoice.shopCustomerId = myCustomer[0].id;
        this.getBalance(myCustomer[0].id);
      }
      this.busy = false;
    },
    addCustomer() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/new",
        {
          name: this.newCustomer.name,
          mobile: this.newCustomer.mobile,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.getCustomers();
            this.tempCustomer = res.data.id;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    addInvoice() {
      this.addBusy = true;
      this.vLoading = true;
      let itemIds = this.selectedProducts.map((x) => x.id);
      let totalCost;
      let sum =
        this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) *
        (1 + Number(this.newInvoice.vat) / 100);
      if (!this.newInvoice.useCredit) {
        totalCost = parseInt(
          (this.selectedProducts
            .map((x) => Number(x.price) * Number(x.amount))
            .reduce((a, b) => a + b, 0) -
            (this.computedTotalPrice * Number(this.newInvoice.discountPercentage)) /
              100) *
            (1 + Number(this.newInvoice.vat) / 100)
        );
      } else {
        if (this.royaltyCreditAmount <= sum) {
          totalCost = parseInt(
            (this.selectedProducts
              .map((x) => Number(x.price) * Number(x.amount))
              .reduce((a, b) => a + b, 0) *
              (100 + Number(this.newInvoice.vat))) /
              100 -
              Number(this.royaltyCreditAmount)
          );
        } else {
          totalCost = 0;
        }
      }
      Axios.post(
        this.baseUrl + "/ppkpms/shop/sales/newSale",
        {
          shopCustomerId: this.newInvoice.shopCustomerId,
          type:
            this.invoiceType == "proforma"
              ? "proforma"
              : this.newInvoice.sellingType,
          date: this.newInvoice.date + " " + this.newInvoice.time,
          paymentType:
            this.newInvoice.sellingType == "definite"
              ? this.newInvoice.income.paymentType
              : undefined,
          totalCost: totalCost,
          vat: Number(this.newInvoice.vat),
          discount: !this.newInvoice.useRoyaltyCredit
            ? this.computedTotalPrice * Number(this.newInvoice.discountPercentage) / 100
            : undefined,
          discountPercentage: Number(this.newInvoice.discountPercentage),
          itemIds: itemIds,
          details: this.selectedProducts,
          //expirationDate: this.expirationDate ? this.expirationDate : "",
          chequeNo:
            this.newInvoice.income.paymentType == "cheque"
              ? this.newInvoice.income.chequeNo
                ? this.newInvoice.income.chequeNo
                : ""
              : undefined,
          chequeDate:
            this.newInvoice.income.paymentType == "cheque"
              ? this.newInvoice.income.chequeDate
                ? this.newInvoice.income.chequeDate
                : ""
              : undefined,
          chequeSayyad:
            this.newInvoice.income.paymentType == "cheque"
              ? this.newInvoice.income.chequeSayyad
                ? this.newInvoice.income.chequeSayyad
                : ""
              : undefined,
          chequeBank:
            this.newInvoice.income.paymentType == "cheque"
              ? this.newInvoice.income.chequeBank
                ? this.newInvoice.income.chequeBank
                : ""
              : undefined,
          chequeStatus:
            this.newInvoice.income.paymentType == "cheque"
              ? this.newInvoice.income.chequeStatus
                ? this.newInvoice.income.chequeStatus
                : ""
              : undefined,
          buyerCardNumber:
            this.newInvoice.income.paymentType == "cardTransfer"
              ? Number(this.newInvoice.income.buyerCardNumber)
              : undefined,
          recipientCardNumber:
            this.newInvoice.income.paymentType == "cardTransfer"
              ? Number(this.newInvoice.income.recipientCardNumber)
              : undefined,
          description: this.newInvoice.income.description
            ? this.newInvoice.income.description
            : "",
          //useRoyaltyCredit: this.useRoyaltyCredit,
          //royaltyDiscount: this.royaltyCreditAmount,
          isPartial:
            this.invoiceType != "proforma"
              ? this.newInvoice.income.isPartial
              : undefined,
          partialAmount: this.newInvoice.income.isPartial
            ? +this.newInvoice.income.partialAmount
            : undefined,
          amount: totalCost,
          expirationDate:
            this.invoiceType == "proforma"
              ? this.newInvoice.expirationDate
                ? this.newInvoice.expirationDate
                : ""
              : undefined,
          subInvoiceLine: this.newInvoice.subInvoiceLine,
          oldInvoiceBalance: this.oldBalance,
          currentInvoiceBalance: this.oldBalance + Number(totalCost),
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.addBusy = false;

          if (res.status == 201) {
            this.newInvoice.shopInvoiceId = res.data.invoiceId;
            // this.toast("فاکتور به ثبت رسید", "success");
            this.vLoading = false;
            //localStorage.setItem(
            //  "oldCustomerBalance",
            //  this.newInvoice.customerBalance
            //);
            if (this.invoiceType == "proforma") {
              this.$router.push(
                "/print/" +
                  this.type +
                  "/preinvoice/" +
                  this.newInvoice.shopInvoiceId
              );
            } else {
              this.$router.push(
                "/print/" +
                  this.type +
                  "/invoice/" +
                  this.newInvoice.shopInvoiceId
              );
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
          this.vLoading = false;
          this.addBusy = false;
        });
    },
    getProducts() {
      this.productsLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/getAll",
        {
          type: this.$route.params.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.products.forEach((p) => {
              p.manualPrice = false;
              p.currentPrice = false;
            });
            this.products2 = JSON.parse(JSON.stringify(this.products));
            this.products2.forEach((p) => {
              p.manualPrice = false;
              p.currentPrice = false;
              p.price = 0;
            });
            this.productsLoading = false;
          } else {
            this.toast(res.data, "error");
            this.productsLoading = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.productsLoading = false;
        });
    },

    init_component() {
      this.invoiceType = this.$route.params.type;
      this.getProducts();
      this.getCustomers();
    },
    refreshData() {
      this.newInvoice = {
        totalPrice: 0,
        customerBalance: "",
        shopCustomerId: null,
        income: {},
        vat: 0,
        discount: 0,
        useCredit: false,
        shopInvoiceId: "",
        sellingType: "respite",
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
        time: moment(new Date()).format("HH:mm"),
        expirationDate: moment(new Date())
          .add(this.expireDuration, "days")
          .format("jYYYY/jMM/jDD"),
        subInvoiceLine:
          "(((نحوه پرداخت فقط 60 روز از تاریخ فاکتور میباشد)))***((((کد ملی آقای محمد حسینی ۵۴۴۹۸۰۸۳۰۵))))",
      };
      this.selectedProducts = [];
      this.customerMobile = "";
    },
    getOptions() {
      Axios.get(this.baseUrl + "/ppkpms/options/getOptions", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            let options = res.data.shopOptions;
            this.newInvoice.subInvoiceLine = options.subInvoiceLine.value;
            if (this.invoiceType == "proforma") {
              this.expireDuration = Number(options.proformaExpireDate.value);
              this.newInvoice.expirationDate = moment(new Date())
                .add(this.expireDuration, "days")
                .format("jYYYY/jMM/jDD");
            }
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getInvoiceData() {
      this.isLoading = true;
      Axios.get(
        this.baseUrl +
          "/ppkpms/shop/sales/getData/" +
          this.$route.query.invoiceId,
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.newInvoice = res.data;
            this.newInvoice.sellingType = "respite";
            this.selectedProducts = this.newInvoice.details;
            this.getBalance(this.newInvoice.shopCustomerId);
            this.isLoading = false;
          } else {
            this.toast(res.data, "error");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response, "error");
          this.isLoading = false;
        });
    },
    //computedIcon(item) {
    //  if (item.royaltyTier == "coper") {
    //    return "/icons8-star-35(1).png";
    //  } else if (item.royaltyTier == "silver") {
    //    return "/icons8-star-35.png";
    //  } else if (item.royaltyTier == "gold") {
    //    return "/icons8-star-35(2).png";
    //  } else if (item.royaltyTier == "diamond") {
    //    return "/icons8-diamond-35.png";
    //  }
    //},
  },
  computed: {
    title() {
      let oldInvoiceType = this.invoiceType;
      let name;

      if (this.$route.path.includes("proforma")) {
        this.invoiceType = "proforma";
        name = "پیش‌فاکتور";
        if (oldInvoiceType != this.invoiceType) this.routeUpdated = true;
      } else {
        this.invoiceType = "invoice";
        name = "فاکتور";
        if (oldInvoiceType != this.invoiceType) this.routeUpdated = true;
      }

      return name;
    },
    disabledProforma() {
      if (
        this.newInvoice.shopCustomerId &&
        this.newInvoice.expirationDate &&
        this.computedDiscount
      ) {
        return false;
      } else return true;
    },
    disabledInvoice() {
      if (
        !this.newInvoice.shopCustomerId ||
        !this.newInvoice.sellingType ||
        !this.computedDiscount
      )
        return true;
      if (this.newInvoice.sellingType != "definite") return false;
      if (!this.newInvoice.income.paymentType) return true;
      if (this.newInvoice.income.paymentType == "cardTransfer") {
        if (
          !this.newInvoice.income.buyerCardNumber ||
          !this.newInvoice.income.recipientCardNumber
        )
          return true;
      }
      if (this.newInvoice.income.paymentType == "cheque") {
        if (
          !this.newInvoice.income.chequeNo ||
          !this.newInvoice.income.chequeBank ||
          !this.newInvoice.income.chequeDate
        )
          return true;
      }
      if (this.newInvoice.income.isPartial) {
        if (!this.newInvoice.income.partialAmount) return true;
        else return false;
      } else return false;
    },
    computedTotalCost() {
      return (
        (this.selectedProducts
          .map((x) => Number(x.price) * Number(x.amount))
          .reduce((a, b) => a + b, 0) -
          this.computedTotalPrice * (this.newInvoice.discountPercentage /
            100)) *
        (1 + Number(this.newInvoice.vat) / 100)
      );
    },
    computedProducts() {
      let filtered;
      filtered = this.products.filter(
        (x) =>
          x.name.toLowerCase().includes(this.titleFilter.toLowerCase()) ||
          x.code.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
      return filtered;
    },
    computedProducts2() {
      let filtered;
      filtered = this.products2.filter(
        (x) =>
          x.name.toLowerCase().includes(this.titleFilter.toLowerCase()) ||
          x.code.toLowerCase().includes(this.titleFilter.toLowerCase())
      );
      return filtered;
    },
    computedTotalPrice() {
      let total = 0;
      this.selectedProducts.forEach((x) => {
        total = total + Number(x.amount) * Number(x.price);
      });
      this.reactivity = !this.reactivity;
      return total;
    },
    computedchequeInfo() {
      if (this.newInvoice.income.paymentType == "cheque") {
        if (
          !this.newInvoice.income.chequeNo ||
          !this.newInvoice.income.chequeBank ||
          !this.newInvoice.income.chequeDate
        ) {
          return true;
        } else return false;
      } else return false;
    },
    computedCardInfo() {
      if (this.newInvoice.income.paymentType == "cardTransfer") {
        if (
          !this.newInvoice.income.recipientCardNumber ||
          !this.newInvoice.income.buyerCardNumber
        ) {
          return true;
        } else return false;
      } else return false;
    },
    computedTotalDiscount() {
      let discount =
        parseInt(
          (this.selectedProducts
            .map((x) => Number(x.price) * Number(x.amount))
            .reduce((a, b) => a + b, 0) *
            this.newInvoice.discountPercentage) /
            100
        ) > 0
          ? parseInt(
              (this.selectedProducts
                .map((x) => Number(x.price) * Number(x.amount))
                .reduce((a, b) => a + b, 0) *
                this.newInvoice.discountPercentage) /
                100
            ).toLocaleString() + " ریال "
          : 0;
      return discount;
    },
    computedDiscount() {
      let result;
      parseInt(
        (this.computedTotalPrice -
          (this.computedTotalPrice * Number(this.newInvoice.discountPercentage)) / 100) *
          (1 + Number(this.newInvoice.vat) / 100)
      ) > 0
        ? (result =
            parseInt(
              (this.computedTotalPrice -
                (this.computedTotalPrice * Number(this.newInvoice.discountPercentage)) /
                  100) *
                (1 + Number(this.newInvoice.vat) / 100)
            ).toLocaleString() + " ریال ")
        : (result = false);

      return result;
    },
  },
  mounted() {
    if (this.$route.query.invoiceId) {
      this.getInvoiceData();
    }
    //if (localStorage.getItem("invoiceData")) {
    //  this.hasData = true;
    //  this.newInvoice = JSON.parse(localStorage.getItem("invoiceData"));
    //  this.newInvoice.sellingType = "respite";
    //  this.selectedProducts = this.newInvoice.details;
    //  this.getBalance(this.newInvoice.shopCustomerId);
    //  localStorage.removeItem("invoiceData");
    //}
    this.getOptions();
    this.getProducts();
    this.getCustomers();
  },
  updated() {
    if (this.newInvoice.shopCustomerId || this.selectedProducts.length) {
      if (this.routeUpdated) {
        this.routeUpdated = false;
        this.refreshData();
        this.getProducts();
      }
    } else {
      this.routeUpdated = false;
    }
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.checkboxPartial {
  width: fit-content !important;
}
.new-invoice {
  .disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: none !important;
  }
  .dashed {
    min-height: 400px;
    .custom-input {
      .v-input__slot {
        width: 100% !important;
      }
      .v-text-field .v-input__control,
      .v-text-field fieldset {
        min-height: 50px !important;
      }
      .mdi:before {
        margin-top: 6px;
      }
    }
  }
  .count-btn {
    width: 30px;
    height: 30px;
    border-radius: 10px;
    background-color: #7e57c2;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    user-select: none;
    font-size: 20px;
  }
  .royaltyCredit label {
    position: static !important;
  }
  .remove-btn {
    min-width: 30px;
    height: 26px;
    border: 1px solid #f3536e;
    border-radius: 4px;
    background-color: FFE4E9;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f3536e;
    cursor: pointer;
    user-select: none;
  }
  .customer-info {
    font-size: 15px;
    background-color: #f2f2f2;
    border-radius: 15px;
    padding: 20px 30px;
  }
  .countField {
    width: 75px;
    border-radius: 8px;
    background-color: #fff;
  }
  .custom-table .bodyClass tr td div {
    padding-top: 0;
  }
}
.custom-intended-table .bodyClass tr td div {
  padding-top: 1px !important;
}
.dialog-card {
  border-radius: 15px !important;
  padding: 10px;

  .custom-table {
    max-height: 500px;
    overflow-y: auto;
    padding-left: 10px;

    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar {
      width: 8px !important;
      background-color: #ccc !important;
      border-radius: 4px !important;
    }
    &::-webkit-scrollbar-thumb {
      background: #979797c7 !important;
      border-radius: 4px !important;
    }
  }
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 50px !important;
    }
    @media only screen and (max-width: 600px) {
      .v-input__slot {
        width: 50% !important;
      }
    }
  }

  .purple-icon {
    path {
      stroke: #7634d6;
    }
  }
}
</style>
